export const SET_ERROR = 'SET_ERROR';
export const MOVIE_LIST = 'MOVIE_LIST';
export const SEARCH_RESULT = 'SEARCH_RESULT';
export const SEARCH_QUERY = 'SEARCH_QUERY';
export const MOVIE_TYPE = 'MOVIE_TYPE';
export const RESPONSE_PAGE = 'RESPONSE_PAGE';
export const MOVIE_DETAILS = 'MOVIE_DETAILS';
export const LOAD_MORE_RESULTS = 'LOAD_MORE_RESULTS';
export const CLEAR_MOVIE_DETAILS = 'CLEAR_MOVIE_DETAILS';
export const APP_ROUTES = 'APP_ROUTES';
export const PATH_URL = 'PATH_URL';
